/**************************************************************************************************/
/*   File: /src/app/shared/services/utils/modal.service.ts                                        */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Wednesday May 15th 2019                                                        */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed May 15 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';
import { Observable, of } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable, ComponentRef, ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';

import { environment } from '../../../../environments/environment';
import { getCurrentLanguage } from '../../../stores/selectors/ui/selectors';
import { RootState } from '../../../stores/states/root/state';
import * as fromModels from '../../models';
import { ConfirmDialogComponent } from '../../components';

/**
 * The plan types service
 */
@Injectable({
  providedIn: 'root'
})
export class ModalService {
 
  /**
   * The constructor
   */
  constructor() {}

  /**
   * Show the modal
   * @param {ElementRef} elementToShow The element to show
   */
  show(elementToShow: ElementRef) {
    jQuery(elementToShow.nativeElement.children[0]).modal('show');
  }

  /**
   * Hide the modal
   * @param {ElementRef} elementToHide The element to hide
   */
  hide(elementToHide: ElementRef) {
    jQuery(elementToHide.nativeElement.children[0]).modal('hide');
  }

}
